type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
};

/**
 * Find-and-replace glyph — "A → B" letter swap (PLAT-10795). Used by the
 * transcript context menu's "Replace Term" action and the toolbar's
 * replaced-terms (redline) toggle. Distinct from `ReplaceIcon`, whose
 * circular double-arrow reads as refresh/restore and stays on the Restore
 * and regenerate actions.
 */
const ReplaceTermIcon = (props: Props) => {
  const {
    width = '18',
    height = '14',
    viewBox = '0 0 20 16',
    strokeColor = 'currentColor',
  } = props;
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none">
      <text
        x="0.5"
        y="12.5"
        fill={strokeColor}
        fontSize="11"
        fontWeight="700"
        fontFamily="var(--font-primary), system-ui, sans-serif"
      >
        A
      </text>
      <path
        d="M8.2 8 H13 M11.2 5.8 L13.4 8 L11.2 10.2"
        stroke={strokeColor}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <text
        x="13.8"
        y="12.5"
        fill={strokeColor}
        fontSize="11"
        fontWeight="700"
        fontFamily="var(--font-primary), system-ui, sans-serif"
      >
        B
      </text>
    </svg>
  );
};

export default ReplaceTermIcon;
